import React from 'react';

import Context from '../../../../context';

import {
  CustomModal,
  CustomButton2,
  ResponsiveView,
} from '../../../../components';

const Delete: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { showModal, setShowModal, isLoading, deleteFunction, selectedYear } =
    React.useContext(Context.AcademicYearScreen);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function onClickDelete(): Promise<void> {
    await deleteFunction!();
  }

  function onClickCancel(): void {
    setShowModal!('NONE');
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  return (
    <section id="academic-year-delete-modal-container">
      <CustomModal label="حذف سال تحصیلی" open={showModal === 'DELETE'} onClose={onClickCancel}>
        <ResponsiveView.Container className="create-form-content">
          <br />
          <span>{`آیا از حذف «${selectedYear?.name ?? ''}» اطمینان دارید؟`}</span>
          <br />
          <br />
          <span>
            اگر سرویسی به این سال تعلق داشته باشد، حذف انجام نمی‌شود — چون آن سرویس‌ها بدون سال می‌مانند و از همه‌ی
            فهرست‌ها ناپدید می‌شوند.
          </span>
          <hr />
          <ResponsiveView.Row className="form-row">
            <ResponsiveView.Column large={6} medium={6} small={12}>
              <CustomButton2 isLoading={isLoading} onClick={onClickCancel} title={'لغو'} type="primary" />
            </ResponsiveView.Column>
            <ResponsiveView.Column large={6} medium={6} small={12}>
              <CustomButton2 isLoading={isLoading} onClick={onClickDelete} title={'حذف'} type="danger" />
            </ResponsiveView.Column>
          </ResponsiveView.Row>
        </ResponsiveView.Container>
      </CustomModal>
    </section>
  );
};

export default Delete;
